import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import Root from './src/app/root/Root';
import { QueryClient, QueryClientProvider } from 'react-query';
import './src/common-utils/libraries/i18n/i18n';
import { SidebarProvider } from '@/common-utils/components/ui/sidebar';
import { TooltipProvider } from '@/common-utils/components/ui/tooltip';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false
    }
  }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <SidebarProvider>
          <TooltipProvider>
            <Root />
          </TooltipProvider>
        </SidebarProvider>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>
);